export const environment = {
  authConfig: {
    loginUrl: 'https://reseau-rec.prodemial.fr/cas/oauth2.0/authorize',
    tokenUrl: 'https://reseau-rec.prodemial.fr/cas/oauth2.0/token',
    logoutUrl: 'https://reseau-rec.prodemial.fr/cas/logout',
    clientId: 'c3nxwh3agx.stellium',
    authGroup: 'APP_MYAPP',
    consultantGroups: ['CN=GOF_CONSULTANT'],
    backOfficeAdminGroups: ['CN=APP_PROXEEMA_USERS_FD_DEVS', 'CN=APP_PROXEEMA_USERS_ADMINS'],
    contratGroups: [
      'CN=APP_PROXEEMA_USERS_ALL_FINZZLE_DIGITAL',
      'CN=APP_PROXEEMA_USERS_FD_DEVS',
      'CN=APP_PROXEEMA_USERS_ADMINS',
      'CN=APP_PROXEEMA_USERS_DSAR',
      'CN=APP_PROXEEMA_USERS_PLACEMENT',
    ],
    migrationGroups: [
      'CN=APP_PROXEEMA_USERS_ALL_FINZZLE_DIGITAL',
      'CN=APP_PROXEEMA_USERS_FD_DEVS',
      'CN=APP_PROXEEMA_USERS_ADMINS',
      'CN=APP_PROXEEMA_USERS_DSAR',
      'CN=APP_PROXEEMA_USERS_PLACEMENT',
    ],
  },
  backEndUrl: 'https://business-gateway-api.int.finzzle-groupe.com/graphql',
  appInsightsKey: 'f80fb188-d91e-4542-83f0-f79dfafa7aea',
  appVersion: 'int',
  displayMyStelliumEvol: false,
  watchMyStelliumGraph: false,
};
